import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';

import { types as sdkTypes, createImageVariantConfig } from '../../util/sdkLoader';
import { findNextBoundary, getStartOf, monthIdString } from '../../util/dates';
import { isTransactionsTransitionInvalidTransition, storableError } from '../../util/errors';
import {
  addOrUpdateMedia,
  addOrUpdateTransactionData,
  cancelStripePaymentIntent,
  chargeCustomer,
  confirmStripePaymentIntent,
  createStripePaymentIntent,
  createTransfers,
  deleteImageFromCloudinary,
  fetchMediaData,
  pauseReminderNotifyToUser,
  refundTransferAfterPayPayment,
  removeMediaData,
  transactionLineItems,
  transitionPrivileged,
  updateAlgoliaData,
  updateListingWithTransaction,
  updateTokenData,
  updateTranistion,
  updateTransactionMetadata,
} from '../../util/api';
import * as log from '../../util/log';
import {
  updatedEntities,
  denormalisedEntities,
  denormalisedResponseEntities,
} from '../../util/data';
import {
  resolveLatestProcessName,
  getProcess,
  isBookingProcess,
} from '../../transactions/transaction';

import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUserNotifications } from '../../ducks/user.duck';
import { transitions } from '../../transactions/transactionDotsProcessPurchase';
import { queryUserReviews, showUserData } from '../ProfilePage/ProfilePage.duck';
import { getOrderNumber, sendSmsNotificationToUsers, stripeCustomer } from '../CheckoutPage/CheckoutPage.duck';
import { getUserDetails } from '../../util/dataExtractor';
import moment from 'moment';
import axios from 'axios';
import { COUNTRY_CODE, getSentOfferText, getSentResponseText, VIDEO_TYPES } from '../../util/types';
import { v4 as uuidv4 } from 'uuid';
import { fetchAuthorData } from '../ListingPage/ListingPage.duck';

const indexName = process.env.REACT_APP_ALGOLIA_LISTING_INDEX;
const { UUID } = sdkTypes;

const MESSAGES_PAGE_SIZE = 100;
const REVIEW_TX_INCLUDES = ['reviews', 'reviews.author', 'reviews.subject'];

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/TransactionPage/SET_INITIAL_VALUES';

export const FETCH_TRANSACTION_REQUEST = 'app/TransactionPage/FETCH_TRANSACTION_REQUEST';
export const FETCH_TRANSACTION_SUCCESS = 'app/TransactionPage/FETCH_TRANSACTION_SUCCESS';
export const FETCH_TRANSACTION_ERROR = 'app/TransactionPage/FETCH_TRANSACTION_ERROR';

export const FETCH_TRANSITIONS_REQUEST = 'app/TransactionPage/FETCH_TRANSITIONS_REQUEST';
export const FETCH_TRANSITIONS_SUCCESS = 'app/TransactionPage/FETCH_TRANSITIONS_SUCCESS';
export const FETCH_TRANSITIONS_ERROR = 'app/TransactionPage/FETCH_TRANSITIONS_ERROR';

export const TRANSITION_REQUEST = 'app/TransactionPage/MARK_RECEIVED_REQUEST';
export const TRANSITION_SUCCESS = 'app/TransactionPage/TRANSITION_SUCCESS';
export const TRANSITION_ERROR = 'app/TransactionPage/TRANSITION_ERROR';

export const FETCH_MESSAGES_REQUEST = 'app/TransactionPage/FETCH_MESSAGES_REQUEST';
export const FETCH_MESSAGES_SUCCESS = 'app/TransactionPage/FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_ERROR = 'app/TransactionPage/FETCH_MESSAGES_ERROR';

export const SEND_MESSAGE_REQUEST = 'app/TransactionPage/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'app/TransactionPage/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'app/TransactionPage/SEND_MESSAGE_ERROR';

export const SEND_REVIEW_REQUEST = 'app/TransactionPage/SEND_REVIEW_REQUEST';
export const SEND_REVIEW_SUCCESS = 'app/TransactionPage/SEND_REVIEW_SUCCESS';
export const SEND_REVIEW_ERROR = 'app/TransactionPage/SEND_REVIEW_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/TransactionPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/TransactionPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/TransactionPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/TransactionPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/TransactionPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/TransactionPage/FETCH_LINE_ITEMS_ERROR';

export const FETCH_AUTHOR_LISTINGS_SUCCESS = 'app/TransactionPage/FETCH_AUTHOR_LISTINGS_SUCCESS';

export const FETCH_MEDIA_SUCCESS = 'app/TransactionPage/FETCH_MEDIA_SUCCESS';

export const DELETE_MEDIA_REQUEST = 'app/TransactionPage/DELETE_MEDIA_REQUEST';
export const DELETE_MEDIA_SUCCESS = 'app/TransactionPage/DELETE_MEDIA_SUCCESS';
export const DELETE_MEDIA_ERROR = 'app/TransactionPage/DELETE_MEDIA_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchTransactionInProgress: false,
  fetchTransactionError: null,
  transactionRef: null,
  transitionInProgress: null,
  transitionError: null,
  fetchMessagesInProgress: false,
  fetchMessagesError: null,
  totalMessages: 0,
  totalMessagePages: 0,
  oldestMessagePageFetched: 0,
  messages: [],
  initialMessageFailedToTransaction: null,
  savePaymentMethodFailed: false,
  sendMessageInProgress: false,
  sendMessageError: null,
  sendReviewInProgress: false,
  sendReviewError: null,
  monthlyTimeSlots: {
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  fetchTransitionsInProgress: false,
  fetchTransitionsError: null,
  processTransitions: null,
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  authorListings: 0,
  uploadedMedia: [],

  deleteMediaInProgress: null,
  deleteMediaError: null
};

// Merge entity arrays using ids, so that conflicting items in newer array (b) overwrite old values (a).
// const a = [{ id: { uuid: 1 } }, { id: { uuid: 3 } }];
// const b = [{ id: : { uuid: 2 } }, { id: : { uuid: 1 } }];
// mergeEntityArrays(a, b)
// => [{ id: { uuid: 3 } }, { id: : { uuid: 2 } }, { id: : { uuid: 1 } }]
const mergeEntityArrays = (a, b) => {
  return a.filter(aEntity => !b.find(bEntity => aEntity.id.uuid === bEntity.id.uuid)).concat(b);
};

export default function transactionPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case FETCH_TRANSACTION_REQUEST:
      return { ...state, fetchTransactionInProgress: true, fetchTransactionError: null };
    case FETCH_TRANSACTION_SUCCESS: {
      const transactionRef = { id: payload.data.data.id, type: 'transaction' };
      return { ...state, fetchTransactionInProgress: false, transactionRef };
    }
    case FETCH_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransactionInProgress: false, fetchTransactionError: payload };

    case FETCH_AUTHOR_LISTINGS_SUCCESS: {
      return { ...state, authorListings: payload };
    }

    case FETCH_TRANSITIONS_REQUEST:
      return { ...state, fetchTransitionsInProgress: true, fetchTransitionsError: null };
    case FETCH_TRANSITIONS_SUCCESS:
      return { ...state, fetchTransitionsInProgress: false, processTransitions: payload };
    case FETCH_TRANSITIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransitionsInProgress: false, fetchTransitionsError: payload };

    case TRANSITION_REQUEST:
      return {
        ...state,
        transitionInProgress: payload,
        transitionError: null,
      };
    case TRANSITION_SUCCESS:
      return { ...state, transitionInProgress: null };
    case TRANSITION_ERROR:
      return {
        ...state,
        transitionInProgress: null,
        transitionError: payload,
      };

    case FETCH_MESSAGES_REQUEST:
      return { ...state, fetchMessagesInProgress: true, fetchMessagesError: null };
    case FETCH_MESSAGES_SUCCESS: {
      const oldestMessagePageFetched =
        state.oldestMessagePageFetched > payload.page
          ? state.oldestMessagePageFetched
          : payload.page;
      return {
        ...state,
        fetchMessagesInProgress: false,
        messages: mergeEntityArrays(state.messages, payload.messages),
        totalMessages: payload.totalItems,
        totalMessagePages: payload.totalPages,
        oldestMessagePageFetched,
      };
    }
    case FETCH_MESSAGES_ERROR:
      return { ...state, fetchMessagesInProgress: false, fetchMessagesError: payload };

    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        sendMessageInProgress: true,
        sendMessageError: null,
        initialMessageFailedToTransaction: null,
      };
    case SEND_MESSAGE_SUCCESS:
      return { ...state, sendMessageInProgress: false };
    case SEND_MESSAGE_ERROR:
      return { ...state, sendMessageInProgress: false, sendMessageError: payload };

    case SEND_REVIEW_REQUEST:
      return { ...state, sendReviewInProgress: true, sendReviewError: null };
    case SEND_REVIEW_SUCCESS:
      return { ...state, sendReviewInProgress: false };
    case SEND_REVIEW_ERROR:
      return { ...state, sendReviewInProgress: false, sendReviewError: payload };

    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case FETCH_MEDIA_SUCCESS:
      return { ...state, fetchMessagesInProgress: false, uploadedMedia: payload };

    case DELETE_MEDIA_REQUEST:
      return { ...state, deleteMediaInProgress: payload, deleteMediaError: null };
    case DELETE_MEDIA_SUCCESS:
      return { ...state, deleteMediaInProgress: null, deleteMediaError: null };
    case DELETE_MEDIA_ERROR:
      return { ...state, deleteMediaInProgress: null, deleteMediaError: payload };


    default:
      return state;
  }
}

// ================ Selectors ================ //

export const transitionInProgress = state => {
  return state.TransactionPage.transitionInProgress;
};

// ================ Action creators ================ //
export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const fetchTransactionRequest = () => ({ type: FETCH_TRANSACTION_REQUEST });
const fetchTransactionSuccess = response => ({
  type: FETCH_TRANSACTION_SUCCESS,
  payload: response,
});
const fetchTransactionError = e => ({ type: FETCH_TRANSACTION_ERROR, error: true, payload: e });

const fetchTransitionsRequest = () => ({ type: FETCH_TRANSITIONS_REQUEST });
const fetchTransitionsSuccess = response => ({
  type: FETCH_TRANSITIONS_SUCCESS,
  payload: response,
});
const fetchTransitionsError = e => ({ type: FETCH_TRANSITIONS_ERROR, error: true, payload: e });

const transitionRequest = transitionName => ({ type: TRANSITION_REQUEST, payload: transitionName });
const transitionSuccess = () => ({ type: TRANSITION_SUCCESS });
const transitionError = e => ({ type: TRANSITION_ERROR, error: true, payload: e });

const fetchMessagesRequest = () => ({ type: FETCH_MESSAGES_REQUEST });
const fetchMessagesSuccess = (messages, pagination) => ({
  type: FETCH_MESSAGES_SUCCESS,
  payload: { messages, ...pagination },
});
const fetchMessagesError = e => ({ type: FETCH_MESSAGES_ERROR, error: true, payload: e });

const sendMessageRequest = () => ({ type: SEND_MESSAGE_REQUEST });
const sendMessageSuccess = () => ({ type: SEND_MESSAGE_SUCCESS });
const sendMessageError = e => ({ type: SEND_MESSAGE_ERROR, error: true, payload: e });

const sendReviewRequest = () => ({ type: SEND_REVIEW_REQUEST });
const sendReviewSuccess = () => ({ type: SEND_REVIEW_SUCCESS });
const sendReviewError = e => ({ type: SEND_REVIEW_ERROR, error: true, payload: e });

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const fetchAuthorListingsSuccess = response => ({
  type: FETCH_AUTHOR_LISTINGS_SUCCESS,
  payload: response,
});

export const fetchMediaSuccess = response => ({
  type: FETCH_MEDIA_SUCCESS,
  payload: response,
});

export const deleteMediaRequest = (data) => ({ type: DELETE_MEDIA_REQUEST, payload: data, });
export const deleteMediaSuccess = () => ({
  type: DELETE_MEDIA_SUCCESS,
});
export const deleteMediaError = error => ({
  type: DELETE_MEDIA_ERROR,
  error: true,
  payload: error,
});

// ================ Thunks ================ //

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  const monthId = monthIdString(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    perPage: 500,
    page: 1,
  };

  return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
    .then(timeSlots => {
      dispatch(fetchTimeSlotsSuccess(monthId, timeSlots));
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

// Helper function for loadData call.
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes && attributes.availabilityPlan && attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const nextBoundary = findNextBoundary(new Date(), 'hour', tz);

    const nextMonth = getStartOf(nextBoundary, 'month', tz, 1, 'months');
    const nextAfterNextMonth = getStartOf(nextMonth, 'month', tz, 1, 'months');

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

// Helper to fetch correct image variants for different thunk calls
const getImageVariants = listingImageConfig => {
  const { aspectWidth = 1, aspectHeight = 1, variantPrefix = 'listing-card' } = listingImageConfig;
  const aspectRatio = aspectHeight / aspectWidth;
  return {
    'fields.image': [
      // Profile images
      'variants.square-small',
      'variants.square-small2x',

      // Listing images:
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
  };
};

const listingRelationship = txResponse => {
  return txResponse.data.data.relationships.listing.data;
};

export const authorListings = userId => (dispatch, getState, sdk) => {
  sdk.listings.query({ authorId: userId?.uuid }).then(res => {
    const itemsCount = res.data.data.length;
    dispatch(fetchAuthorListingsSuccess(itemsCount));
  });
};

export const fetchTransaction = (id, txRole, config) => (dispatch, getState, sdk) => {
  dispatch(fetchTransactionRequest());
  let txResponse = null;

  return sdk.transactions
    .show(
      {
        id,
        include: [
          'customer',
          'customer.profileImage',
          'provider',
          'provider.profileImage',
          'listing',
          'listing.currentStock',
          'booking',
          'reviews',
          'reviews.author',
          'reviews.subject',
        ],
        ...getImageVariants(config.layout.listingImage),
      },
      { expand: true }
    )
    .then(response => {
      txResponse = response;
      const listingId = listingRelationship(response).id;
      const entities = updatedEntities({}, response.data);
      const listingRef = { id: listingId, type: 'listing' };
      const transactionRef = { id, type: 'transaction' };
      const denormalised = denormalisedEntities(entities, [listingRef, transactionRef]);
      const listing = denormalised[0];
      const transaction = denormalised[1];
      const processName = resolveLatestProcessName(transaction.attributes.processName);
      try {
        const process = getProcess(processName);
        const isInquiry = process.getState(transaction) === process.states.INQUIRY;

        // Fetch time slots for transactions that are in inquired state
        const canFetchTimeslots =
          txRole === 'customer' && isBookingProcess(processName) && isInquiry;

        if (canFetchTimeslots) {
          fetchMonthlyTimeSlots(dispatch, listing);
        }
      } catch (error) {
        console.log(`transaction process (${processName}) was not recognized`);
      }

      const canFetchListing = listing && listing.attributes && !listing.attributes.deleted;
      if (canFetchListing) {
        return sdk.listings.show({
          id: listingId,
          include: ['author', 'author.profileImage', 'images'],
          ...getImageVariants(config.layout.listingImage),
        });
      } else {
        return response;
      }
    })
    .then(response => {
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };
      const userId = txResponse?.data?.data?.relationships?.provider?.data?.id;
      const buyerId = txResponse?.data?.data?.relationships?.customer?.data?.id;
      dispatch(addMarketplaceEntities(txResponse, sanitizeConfig));
      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(fetchTransactionSuccess(txResponse));
      dispatch(queryUserReviews(userId));
      dispatch(authorListings(userId));
      dispatch(fetchAuthorData((txRole === 'customer') ? userId : buyerId));
      dispatch(showUserData(buyerId, userId));
      return response;
    })
    .catch(e => {
      dispatch(fetchTransactionError(storableError(e)));
      throw e;
    });
};

const delay = ms => new Promise(resolve => window.setTimeout(resolve, ms));
const refreshTx = (sdk, txId) => sdk.transactions.show({ id: txId }, { expand: true });
const refreshTransactionEntity = (sdk, txId, dispatch) => {
  delay(3000)
    .then(() => refreshTx(sdk, txId))
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      const lastTransition = response?.data?.data?.attributes?.lastTransition;
      // We'll make another attempt if mark-received-from-purchased from default-purchase process is still the latest.
      if (lastTransition === 'transition/mark-received-from-purchased') {
        return delay(8000)
          .then(() => refreshTx(sdk, txId))
          .then(response => {
            dispatch(addMarketplaceEntities(response));
          });
      }
    })
    .catch(e => {
      // refresh failed, but we don't act upon it.
      console.log('error', e);
    });
};

export const fetchMessages = (txId, page, config, isInbox) => (dispatch, getState, sdk) => {
  const paging = { page, perPage: MESSAGES_PAGE_SIZE };
  dispatch(fetchMessagesRequest());

  return sdk.messages
    .query({
      transaction_id: txId,
      include: ['sender', 'sender.profileImage'],
      ...getImageVariants(config.layout.listingImage),
      ...paging,
    })
    .then(response => {
      const messages = denormalisedResponseEntities(response);
      const { totalItems, totalPages, page: fetchedPage } = response.data.meta;
      const pagination = { totalItems, totalPages, page: fetchedPage };
      const totalMessages = getState().TransactionPage.totalMessages;
      // Original fetchMessages call succeeded
      if (!isInbox) {
        dispatch(fetchMessagesSuccess(messages, pagination));
      }

      // Check if totalItems has changed between fetched pagination pages
      // if totalItems has changed, fetch first page again to include new incoming messages.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      if (totalItems > totalMessages && page > 1) {
        dispatch(fetchMessages(txId, 1, config))
          .then(() => {
            // Original fetch was enough as a response for user action,
            // this just includes new incoming messages
          })
          .catch(() => {
            // Background update, no need to to do anything atm.
          });
      }
      return messages;
    })
    .catch(e => {
      dispatch(fetchMessagesError(storableError(e)));
      throw e;
    });
};

export const pauseReminderMailNotification = (data) => (dispatch, getState, sdk) => {
  try {
    pauseReminderNotifyToUser({ ...data });

  } catch (error) {
    console.log(error, '((( ))) => error');
  }
};

export const makeTransition = (
  txId,
  transitionName,
  params,
  provider,
  transactionRole,
  config
) => (dispatch, getState, sdk) => {

  if (transitionInProgress(getState())) {
    return Promise.reject(new Error('Transition already in progress'));
  }
  dispatch(transitionRequest(transitionName));

  return sdk.transactions
    .transition(
      {
        id: txId,
        transition: transitionName,
        params,
      },
      { include: ['listing', 'customer', 'provider'], expand: true }
    )
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(transitionSuccess());
      dispatch(fetchCurrentUserNotifications());
      const txId = response?.data?.data?.id?.uuid || '';
      const { metadata, protectedData, payoutTotal, createdAt } = response?.data?.data?.attributes || {};
      const providerId = (provider && provider.id.uuid) || '';
      const providerEmail = (provider && getUserDetails(provider).email) || '';
      const { mailBatchId } = metadata || {};
      const { newTransactionFlow, paymentIntentId, stripe, totalPaid } = protectedData || {};
      const sellerPhoneNumber = getState().ListingPage?.authorData?.phoneNumber || '';
      const title = response?.data?.included[2]?.attributes?.title || '';
      dispatch(showUserData(response?.data?.included[1]?.id, response?.data?.included[0]?.id)).then(() => {
        const buyerData = getState().ProfilePage.buyerData || {};
        const { enableNotifications = true } = buyerData.attributes?.profile?.publicData || {};

        // If provider has accepted the offer we need to deduct
        // the amount from customer.
        // When customer accepts offer there is separate function
        // to handle that, refer to 'acceptCounterOffer'
        if (transitionName === transitions.OFFER_ACCEPTED_BY_PROVIDER
        ) {
          chargeCustomer({ txId, acceptedBy: 'provider' }).then((res) => {
            addOrUpdateTransactionData(
              {
                txId,
                payoutStatus: "pending",
                paymentStatus: "done",
                payoutAmount: payoutTotal.amount / 100,
                createdAt: moment(createdAt).toDate(),
                paymentAmount: totalPaid.toFixed(2),
              })
            if (enableNotifications) {
              const params = {
                to: `${COUNTRY_CODE}${sellerPhoneNumber}`,
                orderId: txId,
                transactionType: "order", message: `${getSentResponseText(title)}`, type: "offerAccepted"
              };
              dispatch(sendSmsNotificationToUsers(params));
            }
          }).catch(err => console.log('failed to charge customer!'));
        } else if (transitionName === transitions.COUNTER_OFFER_ACCEPTED_BY_CUSTOMER) {
          chargeCustomer({ txId, acceptedBy: 'customer' }).then((res) => {
            addOrUpdateTransactionData(
              {
                txId,
                payoutStatus: "pending",
                paymentStatus: "done",
                payoutAmount: payoutTotal.amount / 100,
                createdAt: moment(createdAt).toDate(),
                paymentAmount: totalPaid.toFixed(2),
              })
          })
            .catch(err => console.log('failed to charge customer!'));

        } else if (transitionName === transitions.OFFER_COUNTERED_BY_PROVIDER) {
          cancelStripePaymentIntent({ txId })
          if (enableNotifications) {
            const params = {
              to: `${COUNTRY_CODE}${sellerPhoneNumber}`,
              orderId: txId,
              transactionType: "order", message: `${getSentResponseText(title)}`, type: "offerAccepted"
            };
            dispatch(sendSmsNotificationToUsers(params));
          }
        }

        if (newTransactionFlow) {
          const promises = [];

          if (transitionName === transitions.MARK_RECEIVED) {
            promises.push(
              createTransfers({
                providerId,
                amount: payoutTotal?.amount,
                txId,
                txId,
                providerEmail,
              })
            );
          }

          else if ((transitionName === transitions.OFFER_REJECTED_BY_PROVIDER) && paymentIntentId && paymentIntentId.length > 0 && stripe && stripe.stripePaymentMethodId) {
            promises.push(cancelStripePaymentIntent({ txId }))
            if (mailBatchId) {
              promises.push(dispatch(pauseReminderMailNotification({ batch_id: mailBatchId, txId: response?.data?.data?.id })));
            }
            if (enableNotifications) {
              const params = {
                to: `${COUNTRY_CODE}${sellerPhoneNumber}`,
                orderId: txId,
                transactionType: "order", message: `${getSentResponseText(title)}`, type: "offerAccepted"
              };
              dispatch(sendSmsNotificationToUsers(params));
            }
          }
          else if (
            transitionName === transitions.OFFER_REJECTED_BY_PROVIDER ||
            (transitionName === transitions.COUNTER_OFFER_REJECTED_BY_CUSTOMER) && paymentIntentId && paymentIntentId.length > 0 && !stripe
          ) {
            const refundPromises = paymentIntentId.map(intent =>
              refundTransferAfterPayPayment({
                paymentIntentId: intent.paymentIntentId, // Access the correct property
                amount: Math.round(intent.amount * 100), // Multiply by 100 and round the amount to an integer
              })
            );

            promises.push(...refundPromises);
            if (transitionName === transitions.OFFER_REJECTED_BY_PROVIDER && mailBatchId) {
              promises.push(dispatch(pauseReminderMailNotification({ batch_id: mailBatchId, txId: response?.data?.data?.id })));
            }
          }
          else if (
            (transitionName === transitions.OFFER_REJECTED_BY_PROVIDER ||
              transitionName === transitions.OFFER_ACCEPTED_BY_PROVIDER ||
              transitionName === transitions.OFFER_COUNTERED_BY_PROVIDER) && mailBatchId
          ) {
            promises.push(dispatch(pauseReminderMailNotification({ batch_id: mailBatchId, txId: response?.data?.data?.id })));
          }

          // Execute all promises in parallel
          Promise.all(promises)
            .then(responses => {
              // Handle the responses from all operations
              console.log('All operations processed');
            })
            .catch(error => {
              // Handle any errors that occur during the process
              console.error('Error processing operations:', error);
            });
        }

      })


      // There could be automatic transitions after this transition
      // For example mark-received-from-purchased > auto-complete.
      // Here, we make 1-2 delayed updates for the tx entity.
      // This way "leave a review" link should show up for the customer.
      refreshTransactionEntity(sdk, txId, dispatch);
      transactionRole && dispatch(fetchTransaction(txId, transactionRole, config));
      return response;
    })
    .catch(e => {
      dispatch(transitionError(storableError(e)));
      log.error(e, `${transitionName}-failed`, {
        txId,
        transition: transitionName,
      });
      throw e;
    });
};

export const makeTransitions = transitionParams => (dispatch, getState, sdk) => {
  const { txId, transitionName, params } = transitionParams;
  if (transitionInProgress(getState())) {
    return Promise.reject(new Error('Transition already in progress'));
  }
  dispatch(transitionRequest(transitionName));

  return sdk.transactions
    .transition({ id: txId, transition: transitionName, params }, { expand: true })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(transitionSuccess());
      dispatch(fetchCurrentUserNotifications());

      // There could be automatic transitions after this transition
      // For example mark-received-from-purchased > auto-complete.
      // Here, we make 1-2 delayed updates for the tx entity.
      // This way "leave a review" link should show up for the customer.
      refreshTransactionEntity(sdk, txId, dispatch);

      return response;
    })
    .catch(e => {
      dispatch(transitionError(storableError(e)));
      log.error(e, `${transitionName}-failed`, {
        txId,
        transition: transitionName,
      });
      throw e;
    });
};

export const fetchMoreMessages = (txId, config) => (dispatch, getState, sdk) => {
  const state = getState();
  const { oldestMessagePageFetched, totalMessagePages } = state.TransactionPage;
  const hasMoreOldMessages = totalMessagePages > oldestMessagePageFetched;

  // In case there're no more old pages left we default to fetching the current cursor position
  const nextPage = hasMoreOldMessages ? oldestMessagePageFetched + 1 : oldestMessagePageFetched;

  return dispatch(fetchMessages(txId, nextPage, config));
};

export const sendMessage = (txId, message, config, isReadData, uploadedMedia = [], transaction = false, txRole = 'provider') => (dispatch, getState, sdk) => {
  dispatch(sendMessageRequest());
  dispatch(getMediaData(txId));
  const { isCustomerRead, isProviderRead, isProviderRole } = isReadData;
  return sdk.messages
    .send({ transactionId: txId, content: message })
    .then(response => {
      const messageId = response.data.data.id;

      // We fetch the first page again to add sent message to the page data
      // and update possible incoming messages too.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      return dispatch(fetchMessages(txId, 1, config))
        .then(() => {

          updateTransactionMetadata({
            id: txId,
            isCustomerRead: isProviderRole ? false : isCustomerRead,
            isProviderRead: !isProviderRole ? false : isProviderRead,
            // uploadedMedia: mediaData || null
          });
          const mediaData = uploadedMedia?.map((e) => ({
            ...e,
            messageId: e.messageId || response.data.data.id.uuid,
            transactionId: txId?.uuid
          }));
          if (uploadedMedia?.length > 0) {
            addOrUpdateMedia({
              uploadedMedia: mediaData || null
            }).then(() => {
              dispatch(getMediaData(txId))

            })
          };
          dispatch(sendMessageSuccess());
          if (transaction) {
            dispatch(showUserData(transaction?.customer?.id, transaction?.provider?.id)).then(() => {
              const sellerData = getState().ProfilePage.sellerData || {};
              const buyerData = getState().ProfilePage.buyerData || {};
              dispatch(fetchAuthorData((txRole === 'customer') ? transaction?.provider?.id : transaction?.customer?.id));
              const sellerPhoneNumber = getState().ListingPage?.authorData?.phoneNumber || '';
              const { enableNotifications = true } = sellerData?.attributes?.profile?.publicData || {};
              const { enableNotifications: buyerEnableNotifications = true } = buyerData?.attributes?.profile?.publicData || {};
              if (buyerEnableNotifications && isProviderRole) {
                const params = {
                  to: `${COUNTRY_CODE}${sellerPhoneNumber}`, orderId: txId?.uuid,
                  transactionType: "order", message: `${getSentResponseText(transaction?.listing?.attributes?.title)}`, type: "messageResponse"
                };
                dispatch(sendSmsNotificationToUsers(params));
              } else if (enableNotifications && !isProviderRole) {
                const params = {
                  to: `${COUNTRY_CODE}${sellerPhoneNumber}`, orderId: txId?.uuid,
                  transactionType: "sale", message: `${getSentOfferText(transaction?.listing?.attributes?.title)}`, type: "messageResponse"
                };
                dispatch(sendSmsNotificationToUsers(params));
              }

            });
          }

          return {
            messageId, uploadedMedia: mediaData
          };
        })
        .catch(() => dispatch(sendMessageSuccess()));
    })
    .catch(e => {
      dispatch(sendMessageError(storableError(e)));
      // Rethrow so the page can track whether the sending failed, and
      // keep the message in the form for a retry.
      throw e;
    });
};

// If other party has already sent a review, we need to make transition to
// transitions.REVIEW_2_BY_<CUSTOMER/PROVIDER>
const sendReviewAsSecond = (txId, transition, params, dispatch, sdk, config) => {
  const include = REVIEW_TX_INCLUDES;

  return sdk.transactions
    .transition(
      { id: txId, transition, params },
      { expand: true, include, ...getImageVariants(config.layout.listingImage) }
    )
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(sendReviewSuccess());
      return response;
    })
    .catch(e => {
      dispatch(sendReviewError(storableError(e)));

      // Rethrow so the page can track whether the sending failed, and
      // keep the message in the form for a retry.
      throw e;
    });
};

// If other party has not yet sent a review, we need to make transition to
// transitions.REVIEW_1_BY_<CUSTOMER/PROVIDER>
// However, the other party might have made the review after previous data synch point.
// So, error is likely to happen and then we must try another state transition
// by calling sendReviewAsSecond().
const sendReviewAsFirst = (txId, transition, params, dispatch, sdk, config) => {
  const include = REVIEW_TX_INCLUDES;

  return sdk.transactions
    .transition(
      { id: txId, transition, params },
      { expand: true, include, ...getImageVariants(config.layout.listingImage) }
    )
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(sendReviewSuccess());
      return response;
    })
    .catch(e => {
      // If transaction transition is invalid, lets try another endpoint.
      if (isTransactionsTransitionInvalidTransition(e)) {
        return sendReviewAsSecond(id, params, role, dispatch, sdk);
      } else {
        dispatch(sendReviewError(storableError(e)));

        // Rethrow so the page can track whether the sending failed, and
        // keep the message in the form for a retry.
        throw e;
      }
    });
};

export const sendReview = (tx, transitionOptionsInfo, params, config) => (
  dispatch,
  getState,
  sdk
) => {
  const { reviewAsFirst, reviewAsSecond, hasOtherPartyReviewedFirst } = transitionOptionsInfo;
  dispatch(sendReviewRequest());

  return hasOtherPartyReviewedFirst
    ? sendReviewAsSecond(tx?.id, reviewAsSecond, params, dispatch, sdk, config)
    : sendReviewAsFirst(tx?.id, reviewAsFirst, params, dispatch, sdk, config);
};

const isNonEmpty = value => {
  return typeof value === 'object' || Array.isArray(value) ? !isEmpty(value) : !!value;
};

export const fetchNextTransitions = id => (dispatch, getState, sdk) => {
  dispatch(fetchTransitionsRequest());

  return sdk.processTransitions
    .query({ transactionId: id })
    .then(res => {
      dispatch(fetchTransitionsSuccess(res.data.data));
    })
    .catch(e => {
      dispatch(fetchTransitionsError(storableError(e)));
    });
};

export const confirmTransactionExtraAttributes = (params) => async (
  dispatch,
  getState,
  sdk
) => {
  const { transactionId, cartData: cartItems, listing } = params || {};
  const listingId = listing?.id?.uuid || '';

  try {
    // Array to hold all promises
    const allPromises = [];

    // Process cart items
    if (cartItems?.length) {
      for (const item of cartItems) {
        const itemListingId = item?.listingId;
        if (itemListingId) {
          // Ensure updateListingWithTransaction returns a Promise
          const updatePromise = updateListingWithTransaction({ listingId: itemListingId, transactionId: transactionId?.uuid });
          const algoliaUpdatePromise = updateAlgoliaData({ indexName, objectID: itemListingId, state: 'closed' });

          allPromises.push(updatePromise, algoliaUpdatePromise);
        }
      }

      // Additional promises for cart items
      const deleteStockPromise = deleteListingStock(cartItems, listing);
      allPromises.push(deleteStockPromise);

      // If you want to update the profile, uncomment this line
      // const updateProfilePromise = dispatch(updateProfile({ protectedData: { bagItems: updatedBagItems } }));
      // allPromises.push(updateProfilePromise);

    } else {
      // No cart items, update the single listing
      const updateSingleListingPromise = updateListingWithTransaction({ listingId, transactionId: transactionId?.uuid });
      const algoliaUpdatePromise = updateAlgoliaData({ indexName, objectID: listingId, state: 'closed' });

      allPromises.push(updateSingleListingPromise, algoliaUpdatePromise);
    }

    // Execute all promises
    const results = await Promise.all(allPromises);
    console.log('Transaction confirmed successfully:', results);
  } catch (error) {
    console.error('Error confirming transaction:', error);
  }
};


export const confirmIntent = (orderParams, paymentIntentId) => (dispatch, getState, sdk) => {
  try {
    confirmStripePaymentIntent({ paymentIntentId, stripePaymentMethodId: orderParams?.stripePaymentMethodId }).then((res) => {
      if (res) {
        dispatch(transitionSuccess());
        if (orderParams?.transitionName === transitions.COUNTER_OFFER_ACCEPTED_BY_CUSTOMER) return dispatch(confirmTransactionExtraAttributes(orderParams))
      }
    })

  } catch (error) {
    console.log(error, '((( ))) => error');
  }

};

export const acceptCounterOffer = (orderParams) => (dispatch, getState, sdk) => {
  try {
    const {
      transactionId,
      transitionName,
      stripeCustomerId,
      totalPaid,
      paymentIntentId: savedIntent,
      transitionParams,
      offerPrice,
      shippingPrice,
      cartData,
      newAmount,
      stripePaymentMethodId
    } = orderParams;

    dispatch(transitionRequest(transitionName));

    const orderData = {
      stockReservationQuantity: 1,
      deliveryMethod: 'shipping',
      cartItems: cartData ? cartData : null,
      shippingPrice,
      offerPrice,
    };

    const queryParams = {
      include: ['booking', 'provider'],
      expand: true,
    };
    if (typeof totalPaid === 'number') {
      return createStripePaymentIntent({
        payment_method_types: ['card'],
        payment_method: stripePaymentMethodId,
        amount: totalPaid,
        confirm: transitionName === transitions.COUNTER_OFFER_ACCEPTED_BY_CUSTOMER ? true : false,
        currency: 'USD',
        ...(stripeCustomerId ? { customer: stripeCustomerId } : {}),
      }).then((intent) => {
        const { paymentIntentId } = intent || {};
        const bodyParams = {
          id: transactionId,
          transition: transitionName,
          params: {
            stockReservationQuantity: 1,
            deliveryMethod: 'shipping',
            listingId: transitionParams.listingId,
            protectedData: {
              ...transitionParams.protectedData,
              paymentIntentId: [{ paymentIntentId, amount: totalPaid / 100 }],
            }
          },
        };
        transitionPrivileged({
          isSpeculative: false,
          orderData,
          bodyParams,
          queryParams
        })
          .then((response) => {
            dispatch(addMarketplaceEntities(response));
            dispatch(transitionSuccess());
            dispatch(fetchCurrentUserNotifications());
            if (transitionName === transitions.COUNTER_OFFER_ACCEPTED_BY_CUSTOMER) {
              const { payoutTotal, createdAt } = response.data.data.attributes || {};
              updateTranistion({ txId: transactionId?.uuid })
              dispatch(confirmTransactionExtraAttributes(orderParams))
              addOrUpdateTransactionData({
                txId: transactionId?.uuid,
                payoutStatus: "pending",
                paymentStatus: "done",
                payoutAmount: payoutTotal.amount / 100,
                createdAt: moment(createdAt).toDate(),
                paymentAmount: totalPaid / 100,
              })
            }

          });
      })
        .catch(err => console.log('failed to charge customer!'));
    }
    else {
      return null;
    }
  } catch (error) {
    console.log(error, '((( ))) => error');
    dispatch(transitionError(storableError(error)));
  }
};

export const fetchTransactionLineItems = ({ orderData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ orderData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        orderData,
      });
    });
};

export const uploadMediaToCloudinary = (params) => (dispatch, getState) => {
  const { uploadedMedia } = params || {};

  if (!uploadedMedia || uploadedMedia.length === 0) {
    return Promise.resolve([]); // Return empty array if no media is provided
  }
  dispatch(sendMessageRequest());
  const uploadPromises = uploadedMedia.map((file) => {
    if (file && file.name) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("folder", "Inquiry Media"); // Folder name
      formData.append("public_id", uuidv4()); // Unique id
      formData.append('resource_type', VIDEO_TYPES.includes(file.type) ? "video" : 'image');

      // Wrap the axios request with a timeout
      const uploadPromise = axios
        .post(`${process.env.REACT_APP_SERVER_MARKETPLACE_ROOT_URL}/api/upload-images`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          const { public_id, secure_url, resource_type } = response?.data || {};
          const data = {
            public_id,
            secure_url,
            resource_type,
            mediaDate: new Date(),
          };
          return data;
        })
        .catch((error) => {
          return null;
        });

      // Create a timeout promise
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => {
          reject(new Error("Media could not be sent due to low internet speed. Please try again"));
        }, 30000) // 20 seconds timeout
      );

      // Race between upload and timeout
      return Promise.race([uploadPromise, timeoutPromise]);
    } else {
      return Promise.resolve(null);
    }
  });

  return Promise.all(uploadPromises)
    .then((responses) => {
      const successfulUploads = responses.filter((res) => res !== null); // Filter out failed uploads
      return successfulUploads;
    })
    .catch((error) => {
      alert(error.message || "Media could not be sent due to low internet speed. Please try again.");
      console.error("Error in uploading media:", error);
      dispatch(sendMessageError(storableError(error)));
    });
};

export const getMediaData = (txId) => (dispatch, getState) => {
  dispatch(fetchMessagesRequest());
  return fetchMediaData({ transactionId: txId?.uuid ? txId?.uuid : txId }).then((response) => {
    dispatch(fetchMediaSuccess(response.data));

    return response;
  })
};

export const deleteSentMedia = (params) => (dispatch, getState) => {
  const { public_id, resource_type, transactionId } = params;

  // Dispatch the request initiation action
  dispatch(deleteMediaRequest(public_id));

  // Step 1: Remove media data from the backend
  return removeMediaData({ public_id })
    .then((removeMediaResponse) => {
      if (!removeMediaResponse) {
        throw new Error('Failed to remove media data from the backend.');
      }

      // Step 2: Fetch updated media data for the transaction
      dispatch(getMediaData(transactionId));

      // Step 3: Delete the media from Cloudinary
      return deleteImageFromCloudinary({ public_id, resource_type });
    })
    .then((cloudinaryResponse) => {
      if (!cloudinaryResponse) {
        throw new Error('Failed to delete media from Cloudinary.');
      }

      // Dispatch success action after successful deletion
      dispatch(deleteMediaSuccess());
    })
    .catch((error) => {
      // Dispatch error action if any step fails
      dispatch(deleteMediaError(storableError(error)));
    });
};

export const updateSmsTrackData = (token) => (dispatch, getState) => {
  return updateTokenData({ token });
}

// loadData is a collection of async calls that need to be made
// before page has all the info it needs to render itself
export const loadData = (params, search, config) => (dispatch, getState) => {
  const txId = new UUID(params.id);
  const state = getState().TransactionPage;
  const txRef = state.transactionRef;
  const txRole = params.transactionRole;
  // const { token } = params || {};

  // In case a transaction reference is found from a previous
  // data load -> clear the state. Otherwise keep the non-null
  // and non-empty values which may have been set from a previous page.
  const initialValues = txRef ? {} : pickBy(state, isNonEmpty);
  dispatch(setInitialValues(initialValues));

  // Sale / order (i.e. transaction entity in API)
  // if(token){
  //   dispatch(updateSmsTrackData(token))
  // }
  return Promise.all([
    dispatch(fetchTransaction(txId, txRole, config)),
    dispatch(fetchMessages(txId, 1, config)),
    dispatch(fetchNextTransitions(txId)),
    dispatch(stripeCustomer()),
    dispatch(getOrderNumber()),
    dispatch(getMediaData(txId)),
  ]);
};
